export default {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: 'rgba(3, 166, 91, 0.07)'
      }
    }
  }
};
